import React from 'react';

import { FormField, SidePageV2, withForm } from '@gogame/form';

import { VALUE_FORMULA } from 'scenes/SmartRules/SmartRuleForm/Conditions';

export const FormulaForm = withForm({
  enableReinitialize: true,
})(({ metrics, onClose, onExited, onChange, open }) => {
  return (
    <SidePageV2
      open={open}
      onClose={onClose}
      onExited={onExited}
      onChange={onChange}
      size={'lg'}
    >
      <SidePageV2.Title title={'Set Formula Text'} />
      <SidePageV2.Content>
        <FormField.CustomMetricCalculator
          name={VALUE_FORMULA}
          metrics={metrics}
        />
      </SidePageV2.Content>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});
